import { SortDirection } from "../common";
import { environmentHttpClient } from "client/Api/httpClient";

export type TagViewModel = {
	id: number;
	name: string;
};

export type TagSaveModel = {
	id: number | null;
	name: string;
};

export enum TagKind {
	Unknown = 0,
	KnowledgeItem = 1,
	UserProjects = 2,
	UserSkillsExp = 3,
	UserEducation = 4,
	UserHobbies = 5,
	Event = 6,
	Announcement = 7,
	App = 8,
	IntegrationFlow = 9
}

export type TagFilterModel = {
	kind: TagKind;
	searchTerm?: string;
	count: number;
	idsToExclude?: readonly number[];
	sortDirection: SortDirection;
};

export function list(
	filter: TagFilterModel,
	signal?: AbortSignal
): Promise<readonly TagViewModel[]> {
	return environmentHttpClient.post<readonly TagViewModel[]>(
		"/Tags",
		filter,
		{ signal }
	);
}

export type TopTagFilterModel = {
	kind: TagKind;
	count: number;
	idsToExclude: readonly number[];
};

export function topTags(
	filter: TopTagFilterModel,
	signal?: AbortSignal
): Promise<readonly TagViewModel[]> {
	return environmentHttpClient.post<readonly TagViewModel[]>(
		"/Tags/TopTags",
		filter,
		{ signal }
	);
}